/* TerraLife — newsletter : −10 % sur la première commande. Après l'inscription Klaviyo, le
   formulaire appelle la fonction newsletter-code (admin-app) : elle crée le code personnel et
   déclenche aussitôt le flow « [Newsletter] Bienvenue −10 % », qui l'envoie en quelques
   secondes. Sa réponse dit tout de suite si le code est accordé (sinon : pourquoi).

   Formulaires branchés : la popup (snippets/terralife-newsletter-popup.liquid), l'encart
   (sections/terralife-newsletter.liquid, [data-tl-newsletter]) et le formulaire du pied de
   page (#ContactFooter). Inscription par l'API publique de Klaviyo (Client Subscriptions).

   Règles de la popup, décidées le 11/10/2026 :
   - jamais avant la réponse au bandeau cookies (cookie tl_consent, assets/terralife-consent.js) ;
   - jamais sur la première page : à la 2e page vue de la visite, ou après 30 s sur la page ;
   - jamais sur le panier ni les pages compte ;
   - fermée : pas avant 30 jours ; jamais pour un inscrit ni un visiteur venu d'un e-mail ;
   - ordinateur : fenêtre centrée ; téléphone : petit bandeau en bas.
   Tout lien vers « #newsletter » l'ouvre directement (barre d'annonce). */
(() => {
  const COMPANY = 'UNBUTk';
  const LIST = 'XmTBB5';
  const CODE_URL = 'https://benlfmuayvbsukzlcssm.supabase.co/functions/v1/newsletter-code';
  const REFUSED = {
    'deja-client': 'Inscription confirmée ! Le −10 % est réservé à une première commande chez nous.',
    'deja-inscrit': 'Inscription confirmée ! Cette boîte mail a déjà reçu son code −10 % : retrouve-le dans tes e-mails.',
    jetable: 'Les adresses e-mail temporaires ne reçoivent pas le code : utilise ton adresse habituelle.',
    'trop-d-essais': 'Trop d’essais d’affilée : réessaie dans quelques minutes.',
  };
  const DELAY_MS = 30000;
  const SNOOZE_MS = 30 * 24 * 60 * 60 * 1000;
  const K = { done: 'tl_nl_done', closed: 'tl_nl_closed', pages: 'tl_nl_pages' };

  const store = (s) => ({
    get: (k) => {
      try {
        return s.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set: (k, v) => {
      try {
        s.setItem(k, v);
      } catch (e) {
        /* navigation privée : la popup reviendra, rien de grave */
      }
    },
  });
  const local = store(window.localStorage);
  const session = store(window.sessionStorage);

  const subscribe = async (email, source) => {
    const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${COMPANY}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: LIST } } },
        },
      }),
    });
    if (!res.ok) throw new Error(String(res.status));
  };

  /** Asks for the welcome code; one retry on a network or server error. */
  const requestCode = async (email) => {
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const res = await fetch(CODE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });
        if (res.ok || res.status === 429) return await res.json();
      } catch (e) {
        /* réseau : un second essai */
      }
    }
    return null;
  };

  /** Wires a form: e-mail field, submit, then the success or error message. */
  const wire = (form, source, onDone) => {
    if (!form || form.dataset.tlNlWired) return;
    form.dataset.tlNlWired = '1';
    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const email = (input?.value || '').trim();
      const msg = form.querySelector('[data-tl-nl-msg]');
      const button = form.querySelector('button[type="submit"], button:not([type])');
      const say = (text, ok) => {
        if (!msg) return;
        msg.textContent = text;
        msg.dataset.state = ok ? 'ok' : 'error';
        msg.hidden = false;
      };
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        say('Vérifie ton adresse e-mail.', false);
        input?.focus();
        return;
      }
      if (button) button.disabled = true;
      try {
        await subscribe(email, source);
        const r = await requestCode(email);
        if (!r) {
          say('Inscription confirmée, mais ton code n’a pas pu être créé : réessaie dans un instant.', false);
          return;
        }
        if (!r.ok && r.reason === 'jetable') {
          say(REFUSED.jetable, false);
          return;
        }
        if (!r.ok && r.reason === 'trop-d-essais') {
          say(REFUSED['trop-d-essais'], false);
          return;
        }
        local.set(K.done, '1');
        form.classList.add('is-done');
        say(r.ok ? 'C’est noté ! Ton code −10 % arrive par e-mail dans un instant (pense à jeter un œil aux spams).' : REFUSED[r.reason] || 'Inscription confirmée !', true);
        if (input) input.value = '';
        onDone?.();
      } catch (e) {
        say('L’inscription n’a pas marché, réessaie dans un instant.', false);
      } finally {
        if (button) button.disabled = false;
      }
    });
  };

  // ---------- Popup ----------
  const pop = document.getElementById('tl-newsletter-pop');
  const fromEmail = /[?&](utm_medium=email|utm_source=klaviyo|_kx=)/.test(location.search);
  if (fromEmail) local.set(K.done, '1');
  const pages = Number(session.get(K.pages) || 0) + 1;
  session.set(K.pages, String(pages));

  const open = () => {
    if (!pop || !pop.hidden) return;
    pop.hidden = false;
    document.body.classList.add('tl-nl-open');
    requestAnimationFrame(() => pop.classList.add('is-open'));
    if (window.matchMedia('(min-width: 750px)').matches) pop.querySelector('input[type="email"]')?.focus();
  };
  const close = () => {
    if (!pop || pop.hidden) return;
    pop.classList.remove('is-open');
    document.body.classList.remove('tl-nl-open');
    setTimeout(() => (pop.hidden = true), 250);
    if (!local.get(K.done)) local.set(K.closed, String(Date.now()));
  };

  if (pop) {
    wire(pop.querySelector('form'), 'Popup site', () => setTimeout(close, 5000));
    pop.querySelectorAll('[data-tl-nl-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href$="#newsletter"]');
      if (!a) return;
      e.preventDefault();
      open();
    });

    const snoozed = Date.now() - Number(local.get(K.closed) || 0) < SNOOZE_MS;
    const eligible = !local.get(K.done) && !snoozed && !pop.hasAttribute('data-off');
    const consented = () => /(?:^|;\s*)tl_consent=/.test(document.cookie);
    if (eligible) {
      const shownAfter = pages >= 2 ? 0 : DELAY_MS;
      const start = Date.now();
      const tick = setInterval(() => {
        if (!consented() || Date.now() - start < shownAfter) return;
        clearInterval(tick);
        open();
      }, 1000);
    }
  }

  // ---------- Other forms ----------
  document.querySelectorAll('form[data-tl-newsletter]').forEach((f) => wire(f, f.dataset.tlNewsletter || 'Encart site'));
  const footer = document.getElementById('ContactFooter');
  if (footer) {
    if (!footer.querySelector('[data-tl-nl-msg]')) {
      const p = document.createElement('p');
      p.className = 'tl-nl__msg';
      p.setAttribute('data-tl-nl-msg', '');
      p.setAttribute('role', 'status');
      p.hidden = true;
      footer.appendChild(p);
    }
    wire(footer, 'Pied de page');
  }
})();
